export const imageExtensions = ["jpg", "png", "jpeg", "tiff", "gif"];
export const videoExtensions = ["mp4", "m3u8"];

export const getFileTypeFromUrl = (url: string) => {
  const extension = (url.split(".").at(-1) ?? "").toLowerCase();
  if (imageExtensions.includes(extension)) return "image";
  else if (videoExtensions.includes(extension)) return "video";
  else return "file";
};
